import React from 'react';
import { TabButton, TabWrapper } from '../../hosc/modals/modals';
// @ts-ignore
import { Button, Loader } from 'arag-ui-lib';
import GenericFormWithChildQuestions from '../genericFormWithChildrenQuestions/genericFormWithChildQuestion';
import { ObjectOfAny, QuestionSchema } from '../../reducers/types';
import GenericParentQuestion from '../genericFormWithChildrenQuestions/genericParentQuestion';
import { useTranslation } from 'react-i18next';
type Props = {
    questions: any;
    formikProps: any;
    posting: boolean;
};
const SurveyForm = (props: Props): JSX.Element => {
    const { questions, formikProps, posting } = props;
    const { t } = useTranslation();
    if (questions.questionTypesLoading) {
        return <Loader variant="inline" label={`${t('updating')}`} />;
    }
    return (
        <div className={'row'}>
            <GenericFormWithChildQuestions>
                {questions.questions.map(
                    (
                        question: QuestionSchema | any,
                        index: number,
                        accQuestions: QuestionSchema[],
                    ) => {
                        if (question.isParent) {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericParentQuestion.Form
                                            index={index}
                                            key={question.id}
                                            question={question}
                                            accQuestions={accQuestions}
                                            questionTypes={
                                                questions.questionTypes as ObjectOfAny
                                            }
                                            notUseFieldValidator={false}
                                            formGroupContainerStyle={{
                                                marginBottom: '4rem',
                                            }}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        } else {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericFormWithChildQuestions.ChildrenElement
                                            key={question.id}
                                            question={question}
                                            questions={questions}
                                            questionTypes={
                                                questions.questionTypes
                                            }
                                            notUseFieldValidator={false}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        }
                    },
                )}
                <GenericFormWithChildQuestions.SubmitForm>
                    <TabWrapper>
                        <TabButton>
                            <Button
                                variant="primary"
                                label={`${t('submit')}`}
                                type={'submit'}
                                arrowDirection="left"
                                disabled={
                                    posting ||
                                    formikProps.isSubmitting ||
                                    formikProps.isValidating
                                }
                            />
                            {posting && (
                                <Loader
                                    variant="inline"
                                    label={`${t('submitting')}`}
                                />
                            )}
                        </TabButton>
                    </TabWrapper>
                </GenericFormWithChildQuestions.SubmitForm>
            </GenericFormWithChildQuestions>
        </div>
    );
};

export default SurveyForm;
